import * as ActionTypes from 'actions/hierarchyUpload'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  hierarchyUploaded: [],
}

// Updates error message to notify about the failed fetches.
export default function hierarchyUpload(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.HIERARCHY_UPLOAD_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.HIERARCHY_UPLOAD_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        hierarchyUploaded: action.uploads,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/hierarchyUpload.js